<template>
  <div class="department">
    <div style="display: flex; flex-direction: column">
      <div class="query-bar" style="font-size: 15px" />
      <div style="flex: auto; display: flex">
        <div
          style="
            width: 250px;
            margin-right: 5px;
            display: flex;
            flex-direction: column;
          "
        >
          <el-tree-ex
            ref="tree"
            v-div-height-fix
            style="max-height: 100%; height: calc(100vh - 130px)"
            url="SystemApplication/Dept/DeptTree"
            :props="{ children: 'fChildrens', label: 'fName' }"
            node-key="fCustomerGroupID"
            :add-state="addState"
            :edit-state="editState"
            :del-state="delState"
            @node-click="handleNodeClick"
            @node-modify="handleNodeModify"
            @node-delete="handleNodeDelete"
          />
        </div>

        <div style="width: 100%" class="tables">
          <el-scrollbar>
            <table>
              <thead>
                <tr>
                  <th style="width: 100%; text-align: left">部门列表</th>
                </tr>
              </thead>
              <tr>
                <td>部门名称</td>
                <td>{{ departData.fName }}</td>
              </tr>
              <tr>
                <td>上级部门</td>
                <td>{{ departData.fParentName }}</td>
              </tr>
              <tr>
                <td>创建人</td>
                <td>{{ departData.fCreater }}</td>
              </tr>
              <tr>
                <td>创建时间</td>
                <td>{{ departData.fCreateTime }}</td>
              </tr>
              <tr>
                <td>最后修改人</td>
                <td>{{ departData.fModify }}</td>
              </tr>
              <tr>
                <td>最后修改时间</td>
                <td>{{ departData.fModifyTime }}</td>
              </tr>
              <tr>
                <td>顺序号</td>
                <td>{{ departData.fSqe }}</td>
              </tr>
              <tr>
                <td>子部门数</td>
                <td>{{ departData.fChildrenCount }}</td>
              </tr>
            </table>
            <table style="margin-top: 10px">
              <thead>
                <tr>
                  <th style="width: 100%; text-align: left">子部门</th>
                </tr>
              </thead>
              <tr>
                <td>部门名称</td>
                <td>子部门数</td>
              </tr>
              <tr v-for="v in departData.fChildrens" :key="v.fDeptID">
                <td>{{ v.fName }}</td>
                <td>{{ v.fChildrenCount }}</td>
              </tr>
            </table>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import addDepartmentForm from './addDepartmentForm'

export default {
  components: {
    addDepartmentForm
  },
  data: function() {
    return {
      loading: false,
      tableData: [],
      treeData: [],
      addState: true,
      editState: true,
      delState: true,
      currentEditItem: null,
      departData: {}
    }
  },
  computed: {},
  mounted: function() {
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants, "userGrants");
    userGrants.forEach((val) => {
      if (val.key == '001001002') {
        this.addState = val.isGrant
      }
      if (val.key == '001001003') {
        this.editState = val.isGrant
      }
      if (val.key == '001001004') {
        this.delState = val.isGrant
      }
    })
    // console.log(this.addState, "this.addState");
    // console.log(this.editState, "this.addState");
    // console.log(this.delState, "this.addState");
  },
  methods: {
    dateTimeFormat: function(row, column, cellValue) {
      var date = cellValue
      // console.log(date, 'date')
      if (date == undefined || date == '') {
        return null
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },

    // 点击树型控件触发
    handleNodeClick(row) {
      // console.log(row, 'row')
      this.departData = row
      this.departData.fCreateTime = this.dateTimeFormat(
        null,
        null,
        this.departData.fCreateTime
      )
      this.departData.fModifyTime = this.dateTimeFormat(
        null,
        null,
        this.departData.fModifyTime
      )
    },
    // 新增或编辑
    handleNodeModify(node, parentNode) {
      // console.log(row)
      const isNew = node == null
      if (isNew) {
        this.currentEditItem = {
          fParentID: parentNode.fDeptID
        }
      } else {
        this.currentEditItem = Object.assign({}, node)
      }
      this.$formDlg({
        title: `${isNew ? '新增部门' : '修改部门'}`,
        width: '30%',
        formTpl: (
          <addDepartmentForm form={this.currentEditItem}></addDepartmentForm>
        ),
        formSubmit: (formData) => this.postData(isNew ? 0 : 1, formData)
      })
    },
    // 删除
    handleNodeDelete(row) {
      this.postData(2, row)
    },
    // 增加or修改部门请求
    postData: function(modifyType, data) {
      return this.$httpPost('SystemApplication/Dept/DeptModify', {
        datalist: JSON.stringify({
          modifyType: modifyType,
          info: data
        })
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.$refs.tree.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    }
  }
}
</script>
<style lang='less'>
.department {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  // .el-tabs {
  //   .el-tabs__content {
  //     height: calc(100vh - 200px);
  //     .el-tab-pane {
  //       height: calc(100vh - 200px);
  //     }
  //   }
  // }
}
</style>
<style lang='less' scoped>
.department {
  .tables {
    margin-top: 10px;
    font-weight: 600;
    font-size: 15px;
    height: calc(100vh - 150px);

    table {
      width: 99%;
      border-collapse: collapse;
      text-indent: 80px;
      border-left: none;

      tr {
        display: flex;
        height: 35px;
        line-height: 35px;

        td {
          flex: 1;
          border-left: none;
        }
        th {
          background: #fdf5e6;
          font-size: 19px;
        }
        td:nth-child(2) {
          flex: 3;
          border-left: none;
          font-weight: 400;
        }
      }
    }
    table,
    td {
      border: 1px solid rgb(158, 158, 158);
    }
  }
  // odd奇数，even偶数
  table tr:nth-child(odd) {
    // background: rgb(238, 236, 236);
    background: #f0f9eb;
  }
}
</style>
